import { Utils } from "../utilities/Utils";
import { IDocument, Document } from "@/model/Document";

export interface IContractor {
    id: number;
    guid: string;
    name: string;
    pclNumber: string;
    primaryContactUserID: number;
    active: boolean;
    created: Date;
    createdBy: string;
    lastUpdated: Date;
    lastUpdatedBy: string;
    image: IDocument;
    defaultBookingOnly: boolean;
}

export class Contractor implements IContractor {

    constructor(data?: IContractor) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IContractor) {
        Utils.clone(data, this);
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    name: string = "";
    pclNumber: string = "";
    primaryContactUserID: number = 0;
    active: boolean = true;
    created: Date = new Date(Utils.emptyDateValue);
    createdBy: string = "";
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedBy: string = "";
    image: Document = new Document();
    defaultBookingOnly: boolean = false;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}